/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MovementTypeListResponse } from '../../models/movement-type-list-response';

export interface WarehouseControllerGetMovementTypes$Params {
}

export function warehouseControllerGetMovementTypes(http: HttpClient, rootUrl: string, params?: WarehouseControllerGetMovementTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MovementTypeListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerGetMovementTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MovementTypeListResponse;
      }>;
    })
  );
}

warehouseControllerGetMovementTypes.PATH = '/warehouse/movement-types';
